import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { from, mergeMap, Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

import { AUTH_SERVICE_TOKEN, AuthService } from '../service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  public constructor(@Inject(AUTH_SERVICE_TOKEN) private readonly authService: AuthService) {}

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isApiUrl: boolean = req.url.startsWith(environment.apiEndpoint);

    if (!isApiUrl) {
      return next.handle(req);
    }

    // Skip authentication for company-registration routes
    if (
      window.location.pathname === '/company-registration' ||
      window.location.pathname === '/company-registration-success' ||
      window.location.pathname === '/company-registration-error'
    ) {
      return next.handle(req);
    }

    return from(this.authService.getToken()).pipe(
      mergeMap((token: string) => {
        const authorizedReq: HttpRequest<any> = req.clone({
          headers: req.headers.set('Authorization', `Bearer ${token}`),
        });

        return next.handle(authorizedReq);
      }),
    );
  }
}
